import { Button, Typography } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { Spinner } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import Iconify from 'src/components/Iconify';
import { bookType, headerType, renderTypeObj, roleType } from 'src/Helpers/constant';
import { breadcrumAction } from 'src/Redux/Action/breadcrumAction';
import BookHeaderModal from 'src/sections/PopUp/BooksHeaderModal';
import BookUpdateHeaderModal from 'src/sections/PopUp/BookUpdateHeaderModal';
import DeleteModal from 'src/sections/PopUp/DeleteModal';
import InstructorHeaderModal from 'src/sections/PopUp/InstuctorModal/InstructorHeaderModal';
import InstructorHeaderUpdateModal from 'src/sections/PopUp/InstuctorModal/InstructorHeaderUpdateModal';
import { bookCategoryService } from 'src/Services/ApiHandlers/bookCategoryService';
import { instructorServices } from 'src/Services/WebApiHandler/instructorServices';
import { studentServices } from 'src/Services/WebApiHandler/studentServices';
import webBookServices from 'src/Services/WebApiHandler/webBookServices';
import LibrarySidebar from '../../LibraryContainer/LibrarySidebar';
import DragListing from '../HtmlHelper/DragListing';
import HelperFunction from '../HtmlHelper/HelperFunction';
import { AuthorReaderRender, InstructorRender, StudentHeaderRender } from '../HtmlHelper/HtmlRender';
import LibraryNavigateBar from '../HtmlHelper/LibraryNavigateBar';
import NavbarHtmlContent from '../HtmlHelper/NavbarHtmlContent';
import { MathJax } from 'better-react-mathjax';

const HeaderThree = ({ setArrayList }) => {
  const param = useLocation();
  const urlthis = param.pathname.split('/');
  urlthis.shift();

  let isClone = urlthis.find((element) => {
    if (element.includes('-clone')) {
      return true;
    }
  });

  function getRenderType() {
    for (let i = 1; i < urlthis.length; i++) {
      return renderTypeObj[urlthis[i]];
    }
  }
  const renderType = getRenderType();
  const urlparam = useParams();

  const dispatch = useDispatch();
  const state = useSelector((state) => state.contentHTML.htmlContent);
  const stateName = useSelector((state) => state.nameDetail.nameContent);
  const { id, htmltype, mainid } = state;
  const [headerThreeHtmlList, setHeaderThreeHtmlList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [menuType, setMenutype] = useState(isClone ? 'CUSTOM' : 'REGULAR');
  const [type, setType] = useState('header-3');
  const [actionState, setActionState] = useState({
    add: false,
    edit: false,
    delete: false,
  });
  const [showSidebar, setShowSidebar] = useState(false);
  //   const [chapterName, setChapterName] = useState()
  const [chapterDeleteObject, setChapterDeleteObject] = useState();
  const [openHeaderModal, setOpenHeaderModal] = useState(false);
  const [openUpdateHeaderModal, setOpenUpdateHeaderModal] = useState(false);

  const [openChapterModal, setOpenChapterModal] = useState(false);
  const [openUpdateChapterModal, setOpenUpdateChapterModal] = useState(false);
  const [chapterElement, setChapterElement] = useState();
  const [openChapterDeleteModal, setOpenChapterDeleteModal] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  const [headerContent, setHeaderContent] = useState({ data: '', type: '' });
  const [updateHeaderContent, setUpdateHeaderContent] = useState({
    dataHeader: '',
    type: '',
  });
  const [deleteHeaderObject, setDeleteHeaderObject] = useState();
  const [rolesArray, setRolesArray] = useState();
  const [customError, setCustomError] = useState();

  const navigate = useNavigate();

  useEffect(() => {
    getCommonHeaderCall();
  }, [type, menuType, mainid]);

  const getCommonHeaderCall = () => {
    let bookname = urlparam.id;
    if (isClone && menuType !== 'CUSTOM') {
      let bookIndex = urlparam.id.lastIndexOf('-');
      bookname = urlparam.id.slice(0, bookIndex);
    }

    setIsLoading(true);
    bookCategoryService
      .getStaticHeaderThreeContent(
        bookname,
        urlparam.chapter,
        urlparam.header,
        urlparam.headertwo,
        urlparam.headerthree
      )
      .then((response) => {
        let bookTypeCheck = response.data?.permissions?.bookType;
        let arrayNew = response.data?.permissions?.rolesData.find((item) => {
          if (bookType.main === bookTypeCheck && item.type === roleType.AUTHOR) {
            return item;
          } else if (bookType.clone === bookTypeCheck && item.type === roleType.INSTRUCTOR) {
            return item;
          } else if (bookType.main === bookTypeCheck && item.type === roleType.READER) {
            return item;
          } else if (bookType.main === bookTypeCheck && item.type === roleType.PUBLIC) {
            return item;
          } else if (bookType.clone === bookTypeCheck && item.type === roleType.PUBLIC) {
            return item;
          }
        });
        if (response.code === 200) {
          setIsLoading(false);
          setHeaderThreeHtmlList(response.data);
          commonDispatchCall(response.data);
          setRolesArray(arrayNew);
          sequenceCall(arrayNew);
          setCustomError('');
        } else if (response.code === 403) {
          setIsLoading(false);
          commonDispatchCall(response.data);
          setHeaderThreeHtmlList(response.data);
          setRolesArray(arrayNew);
          sequenceCall(arrayNew);
          setCustomError(response.message);
        } else if (response.code === 404) {
          setIsLoading(false);
          setHeaderThreeHtmlList([]);
          setCustomError('This header is not available in this format');
        }
      });
  };

  const sequenceCall = (arrayNew) => {
    switch (arrayNew.type) {
      case roleType.AUTHOR:
        getStaticPaginationCall();
        break;
      case roleType.INSTRUCTOR:
        getInstructorPagination();
        break;
      case roleType.READER:
        getStaticPaginationCall();
        break;
      case roleType.STUDENT:
        getStudentPagination();
        break;
      case roleType.PUBLIC:
        getStaticPaginationCall();
        break;
      default:
        break;
    }
  };

  const getStaticPaginationCall = () => {
    bookCategoryService
      .getStaticPagination(urlparam.id)
      .then((response) => {
        if (response.status === true) {
          if (response.data.length) {
            // dispatch(regularExpressArraySequenceAction(response.data))
            setArrayList(response.data);
            const myindex = response.data.findIndex(function (item, i) {
              return (
                item.slug === urlparam.headerthree &&
                item.header2_slug === urlparam.headertwo &&
                item.header1_slug === urlparam.header &&
                item.chapter_slug === urlparam.chapter &&
                item.book_slug === urlparam.id
              );
            });
            setType(response.data[myindex].type);
            setDeleteHeaderObject(response.data[myindex]);
            setHeaderContent({
              data: response.data[myindex - 1],
              type: headerType.header3,
            });
            setUpdateHeaderContent({
              dataHeader: response.data[myindex],
              type: headerType.header3,
            });
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getAuthorPagination = () => {
    webBookServices
      .getAuthorPaginationApi(urlparam.id)
      .then((response) => {
        if (response.status === true) {
          if (response.data.length) {
            setArrayList(response.data);
            const myindex = response.data.findIndex(function (item, i) {
              return (
                item.slug === urlparam.headerthree &&
                item.header2_slug === urlparam.headertwo &&
                item.header1_slug === urlparam.header &&
                item.chapter_slug === urlparam.chapter &&
                item.book_slug === urlparam.id
              );
            });
            setType(response.data[myindex].type);
            setDeleteHeaderObject(response.data[myindex]);
            setHeaderContent({
              data: response.data[myindex - 1],
              type: headerType.header3,
            });
            setUpdateHeaderContent({
              dataHeader: response.data[myindex],
              type: headerType.header3,
            });
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getInstructorPagination = () => {
    if (menuType === 'CUSTOM') {
      instructorServices
        .getInstructorPaginationApi(urlparam.id)
        .then((response) => {
          if (response.status === true) {
            if (response.data.length) {
              setArrayList(response.data);

              const myindex = response.data.findIndex(function (item, i) {
                return (
                  item.slug === urlparam.headerthree &&
                  item.header2_slug_clone === urlparam.headertwo &&
                  item.header1_slug_clone === urlparam.header &&
                  item.chapter_slug_clone === urlparam.chapter &&
                  item.book_slug_clone === urlparam.id
                );
              });

              if (myindex > -1) {
                setDeleteHeaderObject(response.data[myindex]);
                setHeaderContent({
                  data: response.data[myindex - 1],
                  type: headerType.header3,
                });
                setUpdateHeaderContent({
                  dataHeader: response.data[myindex],
                  type: headerType.header3,
                });
              }
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      instructorServices
        .getInstructorMainPaginationApi(urlparam.id)
        .then((response) => {
          if (response.status === true) {
            if (response.data.length) {
              setArrayList(response.data);
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const getStudentPagination = () => {
    if (menuType === 'CUSTOM') {
      studentServices
        .getStudentMainPaginationApi(urlparam?.id)
        .then((response) => {
          if (response.status === true) {
            if (response.data.length) {
              setArrayList(response.data);
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      studentServices
        .getStudentPaginationApi(urlparam?.id)
        .then((response) => {
          if (response.status === true) {
            if (response.data.length) {
              setArrayList(response.data);
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const handleUpdate = (content) => {
    const updateCon = document.getElementById(`bookContent-${content._id}`).innerHTML;
    if (rolesArray?.type === roleType.AUTHOR) {
      HelperFunction.headerThreeUpdate(content, updateCon, menuType, 'header-3');
    } else if (rolesArray?.type === roleType.INSTRUCTOR && menuType === 'CUSTOM') {
      HelperFunction.headerThreeInstructorUpdate(content, updateCon, content?.book_id);
    }
  };

  const deleteHandler = () => {
    let postData = {
      book_id: stateName?.book_data?._id,
    };

    let isAuthor = rolesArray.type === roleType.AUTHOR ? true : false;
    let deleteCall = isAuthor ? webBookServices.deleteChapterHeaderApi : instructorServices.deleteChapterHeaderApi;

    deleteCall(deleteHeaderObject?.type, deleteHeaderObject?._id, postData)
      .then((response) => {
        if (response.code === 200) {
          setOpenModal(false);
          toast.success(response.message);
          navigate(`/library/${urlparam.id}`);
        } else {
          setOpenModal(false);
          toast.success(response.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  function commonDispatchCall(response) {
    // const idx = Object.values(renderTypeObj).indexOf(renderType);
    // const currentPath = (Object.keys(renderTypeObj)[idx]);

    dispatch(
      breadcrumAction([
        {
          title: 'Home',
          url: '/',
          is_enable: true,
          is_Home: true,
          id: '',
        },
        {
          title: 'Library',
          url: '/library',
          is_enable: true,
          is_Home: false,
          id: '',
        },
        {
          title: `${response?.book_name}`,
          url: `/library/${response?.book_slug}`,
          is_enable: true,
          is_Home: false,
          id: response?.book_id,
        },
        {
          title: `${
            response?.permissions?.bookType === 'main' ? response.permissions.chapter : response.permissions.chapter
          }`,
          url: `/library/${response?.book_slug}/${response?.chapter_slug}`,
          is_enable: true,
          is_Home: false,
          id: response?.chapter_id,
        },
        {
          title: `${
            response?.permissions?.bookType === 'main' ? response.permissions?.header1 : response.permissions?.header1
          }`,
          url: `/library/${response?.book_slug}/${response?.chapter_slug}/${response?.header1_slug}`,
          is_enable: true,
          is_Home: false,
          id: response._id,
        },
        {
          title: `${
            response?.permissions?.bookType === 'main' ? response.permissions?.header2 : response.permissions?.header2
          }`,
          url: `/library/${response?.book_slug}/${response?.chapter_slug}/${response?.header1_slug}/${response?.header2_slug}`,
          is_enable: true,
          is_Home: false,
          id: response._id,
        },
        {
          title: `${response?.permissions?.bookType === 'main' ? response?.header3_name : response?.header3_name}`,
          url: `/library/${response?.book_slug}/${response?.chapter_slug}/${response?.header1_slug}/${response?.header2_slug}/${response?.slug}`,
          is_enable: false,
          is_Home: false,
          id: response._id,
        },
      ])
    );
  }

  return (
    <React.Fragment>
      <div className="Library_sec_view bg-light">
        <LibraryNavigateBar chapterName={headerThreeHtmlList?.header3_name} chapterType={'author'} id={id} />
      </div>

      <NavbarHtmlContent
        setActionState={setActionState}
        actionState={actionState}
        setShowSidebar={setShowSidebar}
        showSidebar={showSidebar}
        menuType={menuType}
        renderType={rolesArray}
      />

      <DragListing
        setOpenChapterModal={setOpenChapterModal}
        actionState={actionState}
        setOpenUpdateChapterModal={setOpenUpdateChapterModal}
        setChapterElement={setChapterElement}
        setOpenChapterDeleteModal={setOpenChapterDeleteModal}
        setChapterDeleteObject={setChapterDeleteObject}
        showSidebar={showSidebar}
        menuType={menuType}
        renderType={rolesArray}
        getInstructorCall={getCommonHeaderCall}
        setHeaderContent={setHeaderContent}
        setUpdateHeaderContent={setUpdateHeaderContent}
        params={urlparam}
        isClone={isClone}
      />

      <div className="w-75 m-auto">
        <div className="sidebarcontent py-5">
          <LibrarySidebar
            renderType={!isClone ? 'author' : 'author_none'}
            setMenutype={setMenutype}
            menuType={menuType}
          />
        </div>
      </div>

      <div className="rightWrapper">
        {rolesArray?.type === roleType.AUTHOR || (rolesArray?.type === roleType.INSTRUCTOR && menuType === 'CUSTOM') ? (
          <div className="d-flex justify-content-end m-auto w-75">
            <div className="my-3">
              {actionState.add && (
                <Button
                  variant="contained"
                  type="button"
                  onClick={() => setOpenHeaderModal(true)}
                  startIcon={<Iconify icon={'eva:plus-fill'} className="user-btn" />}
                  className="p-2 me-3"
                >
                  Add
                </Button>
              )}

              {actionState.edit && (
                <Button
                  variant="contained"
                  type="button"
                  onClick={() => setOpenUpdateHeaderModal(true)}
                  startIcon={<Iconify icon={'eva:edit-fill'} className="user-btn" />}
                  className="p-2 me-3 bg-info"
                >
                  Edit
                </Button>
              )}
              {actionState.delete && (
                <Button
                  variant="contained"
                  type="button"
                  onClick={() => setOpenChapterDeleteModal(true)}
                  startIcon={<Iconify icon={'eva:trash-fill'} className="user-btn" />}
                  className="p-2 bg-danger"
                >
                  Delete
                </Button>
              )}
            </div>
          </div>
        ) : (
          ''
        )}
        <MathJax dynamic className="ck-content">
          <article className="mainlesson">
            {rolesArray?.type === roleType.AUTHOR || rolesArray?.type === roleType.PUBLIC ? (
              <AuthorReaderRender
                content={headerThreeHtmlList}
                menuType={menuType}
                renderType={rolesArray}
                handleUpdate={() => handleUpdate(headerThreeHtmlList)}
              />
            ) : (
              ''
            )}

            {rolesArray?.type === roleType.INSTRUCTOR && (
              <InstructorRender
                content={headerThreeHtmlList}
                menuType={menuType}
                handleUpdate={() => handleUpdate(headerThreeHtmlList)}
              />
            )}
            {rolesArray?.type === roleType.READER ? (
              <StudentHeaderRender htmlType={menuType} content={headerThreeHtmlList} />
            ) : (
              ''
            )}
            {customError && (
              <Typography variant="h4" sx={{ p: '4rem', textAlign: 'center' }}>
                {customError}
              </Typography>
            )}
          </article>
        </MathJax>
        {isLoading && (
          <div className="loading">
            <Spinner animation="border" />;
          </div>
        )}

        {rolesArray?.type === roleType.AUTHOR && type === headerType.header3 && (
          <>
            <BookHeaderModal
              open={openHeaderModal}
              setOpen={setOpenHeaderModal}
              bookId={headerContent.data?.book_id}
              headerdata={headerContent}
              getChapterHeader={getCommonHeaderCall}
            />
            <BookUpdateHeaderModal
              typeOfMenu={htmltype}
              open={openUpdateHeaderModal}
              setOpen={setOpenUpdateHeaderModal}
              bookId={updateHeaderContent.dataHeader?.book_id}
              headerdata={updateHeaderContent}
              getChapterHeader={getCommonHeaderCall}
            />
            <DeleteModal setOpen={setOpenModal} open={openModal} deleteHandler={deleteHandler} />
          </>
        )}

        {rolesArray?.type === roleType.INSTRUCTOR && menuType === 'CUSTOM' && (
          <>
            <InstructorHeaderModal
              open={openHeaderModal}
              setOpen={setOpenHeaderModal}
              bookId={headerContent.data.book_id_clone}
              headerdata={headerContent}
              getChapterHeader={getCommonHeaderCall}
            />
            <InstructorHeaderUpdateModal
              typeOfMenu={menuType}
              open={openUpdateHeaderModal}
              setOpen={setOpenUpdateHeaderModal}
              bookId={updateHeaderContent.dataHeader?.book_id_clone}
              headerdata={updateHeaderContent}
              getChapterHeader={getCommonHeaderCall}
            />
            <DeleteModal setOpen={setOpenModal} open={openModal} deleteHandler={deleteHandler} />
          </>
        )}
      </div>
    </React.Fragment>
  );
};

export default HeaderThree;
